exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blue-line[data-v-a8abc506]{background:linear-gradient(180deg,transparent calc(50% - 1px),#0057b8 50%,transparent calc(50% + 1px))}", ""]);

// exports
